export const buildCarPreviewList = (carKeys: any, excelData: any) => {
  let list = []
  excelData.forEach((item: any) => {
    list.push({
      country: item[carKeys.country],
      distanceKlm: item[carKeys.distanceKlm],
      vehicleModel: item[carKeys.vehicleModel],
      vehiclefuel: item[carKeys.vehicleFuel],
    })
  })
  return list
}

export const buildPlanePreviewList = (planeKeys: any, excelData: any) => {
  let list = []
  excelData.forEach((item: any) => {
    list.push({
      from: item[planeKeys?.from],
      to: item[planeKeys?.to],
      paxes: item[planeKeys?.paxes],
      'class': item[planeKeys?.classType],
      roundTrip: item[planeKeys?.roundtrip],
      idTrip: item?.IdViaje
    })
  })
  return list
}

export const buildParcelPreviewList = (parcelKeys: any, excelData: any) => {
  let list = []
  excelData.forEach((item: any) => {
    list.push({
      ...item,
      from: item[parcelKeys?.from],
      to: item[parcelKeys?.to],
      weigth: item[parcelKeys?.weigth],
      fleetType: item[parcelKeys?.fleetType]
    })
  })
  return list
}


const getSubArray = (list: any[]) => {
  return list?.map(item => {
    return {
      oldItem: item,
      from: item?.from,
      to: item?.to,
      weight: item?.weigth,
      vehicle: {
        fleet: item?.fleetType
      }
    }
  })
}

export const getParcelSplitedArrayIntoPieces = (list: any[], bulkNumber: number) => {
  const array = [...list]
  if (array?.length <= bulkNumber) {
    return [getSubArray(array)]
  }
  let newArray = []
  while (array?.length > bulkNumber) {
    newArray.push(getSubArray(array?.slice(0, bulkNumber)))
    array?.splice(0, bulkNumber)
  }
  if (array.length > 0) {
    newArray.push(getSubArray(array.slice(0, array?.length)))
    array?.splice(0, array?.length)
  }
  return newArray
}
